import {FormBuilder, Validators} from '@angular/forms';
import {REGEX_EMAIL} from "@core/app.costants";

export function createLoginForm() {
  return new FormBuilder().group({
    email: ['', [Validators.required, Validators.pattern(REGEX_EMAIL)]],
    password: ['', [Validators.required]]
  });
}
